import React from "react";

const DotIcon = ({ size = 16, color = "#FF0000", className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="8" cy="8" r="8" fill={color} />
    </svg>
  );
};

export default DotIcon;
